import axios from 'axios';

import { getApiBaseUrl } from './apiBaseUrl';

/** Same API origin as the main client, but no auth header and no global 401 redirect — for public CMS HTML. */
const axiosPublic = axios.create({
  baseURL: getApiBaseUrl(),
});

export default axiosPublic;
